module.exports = __webpack_public_path__ + "img/modem.61b01e88.jpg";